<ngx-spinner bdColor="rgba(0,0,0,0)"
             size="medium"
             color="#000000"
             type="ball-spin-clockwise">
</ngx-spinner>

<div class="row">

  <div class="columnnbv1">
    <div class="position-fixed-scans2 border-right2  height-100pe">
      <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 padding-right-0px">
        <!--<div class="row"></div>-->
        <div class="card height-100vh">
          <div class="card-header wh-header border-bottom padding-bottom-0px">
            <div class="row">
              <div class="col-md-12">
                <label class="margin-bottom-0px">Patient Details</label>
              </div>
            </div>
          </div>
          <div class="card-body">
            <div class="row border-bottom-2px" *ngIf="SelectedPatientFormattedCode">
              <!--<div class="padding-left-14px padding-right-14px padding-bottom-14px"></div>-->
              <!--<div class="card"></div>-->
              <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                <div class="row">
                  <div class="col-md-12 text-align-center padding-left-0px">
                    <img class="img-circle-50" [src]='SelectedPatientFormattedCode.PatientImageFile' onError="this.src='dummy.jpg';">
                    <!--<img class="img-circle-50" src="DR SITARAM.jpg" onError="this.src='dummy.jpg';">-->
                  </div>
                </div>
                <div class="row margin-left-zero margin-top-10">
                  <div class="col-md-12 text-align-center padding-left-0px">
                    <label class="font-size-16px margin-bottom-0px">{{SelectedPatientFormattedCode.DisplayName}}</label>
                  </div>
                </div>
                <div class="row margin-left-zero">
                  <div class="col-md-12 text-align-center padding-left-0px">
                    <label class="font-size-16px margin-bottom-0px">{{SelectedPatientFormattedCode.Gender}}/{{SelectedPatientFormattedCode.Age}}</label>
                  </div>
                </div>
                <div class="row margin-left-zero">
                  <div class="col-md-12 text-align-center padding-left-0px">
                    <label class="font-size-16px margin-bottom-0px">{{SelectedPatientFormattedCode.FormattedCode}}</label>
                  </div>

                </div>
                <div class="row margin-left-zero">
                  <div class="col-md-12 text-align-center padding-left-0px">
                    <label class="font-size-16px margin-bottom-0px">{{SelectedPatientFormattedCode.Telephone1}}</label>
                  </div>

                </div>

              </div>
            </div>


            <div class="row border-bottom-2px margin-top-10" hidden>

              <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                <div class="row border-bottom-2px">
                  <div class="col-md-9">
                    <label class="margin-bottom-0px font-weight-normal">Doctor's</label>
                  </div>
                  <!--<div class="col-md-2">
                    <a (click)="docedit()" class="nav-link-hand education-navlink" title="Edit Plan">
                      <span class="badge"><i class="fas fa-pencil-alt"></i></span>
                    </a>
                  </div>-->
                </div>

                <div class="row margin-top-10">
                  <div class="col-md-10">
                    <label class="margin-bottom-0px font-weight-normal">Prescribing Doctor</label>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-3">
                    <div class="row">
                      <a class="nav-link-hand margin-left-5px">
                        <img class="user-image-circle-65px img2" src="DR SITARAM.jpg">
                      </a>
                    </div>
                  </div>
                  <div class="col-md-9 padding-left-0px">
                    <div class="row margin-left-0px" *ngFor="let l of CurrentPrescribingDoctor">
                      <label class="margin-bottom-0px f2 td-elipsis-appoinment1">{{l.DoctorName}}</label>
                    </div>

                    <div class="row margin-left-0px" *ngIf="Prescriberdesg">
                      <label class="margin-bottom-0px font-size-11px">{{Prescriberdesg}}</label>
                    </div>

                  </div>

                </div>
                <div class="row">
                  <div class="col-md-10">
                    <label class="margin-bottom-0px font-weight-normal"></label>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-10">
                    <label class="margin-bottom-0px font-weight-normal">Referring Doctor</label>
                  </div>
                </div>
                <div class="row margin-bottom-10px">
                  <div class="col-md-3">
                    <div class="row">
                      <a class="nav-link-hand margin-left-5px">
                        <img class="user-image-circle-65px img2" src="DR SITARAM.jpg">
                      </a>
                    </div>
                  </div>
                  <div class="col-md-9 padding-left-0px">
                    <div class="row margin-left-0px" *ngIf="Referalname">
                      <label class="margin-bottom-0px f2 td-elipsis-appoinment1">{{Referalname}}</label>
                    </div>

                    <div class="row margin-left-0px" *ngIf="Referaldesg">
                      <label class="margin-bottom-0px font-size-11px">{{Referaldesg}}</label>
                    </div>

                  </div>
                </div>
              </div>

            </div>
            <div class="row" hidden>

              <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                <div class="row margin-top-10">
                  <div class="col-md-6">
                    <label class="margin-bottom-0px font-size-12px font-weight-bold data-color-new">Total Bill</label>
                  </div>:
                  <div class="col-md-5 padding-right-0px">
                    <label class="margin-bottom-0px f2 color-Assign " *ngIf="CurrentNewBillData">{{CurrentNewBillData.TotalBill}}</label>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6">
                    <label class="margin-bottom-0px font-size-12px font-weight-bold data-color-new">Discount</label>
                  </div>:
                  <div class="col-md-5 padding-right-0px">
                    <label class="margin-bottom-0px f2 color-Assign" *ngIf="CurrentNewBillData">{{CurrentNewBillData.TotalDiscount}}</label>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6">
                    <label class="margin-bottom-0px font-size-12px font-weight-bold data-color-new">Net Payable</label>
                  </div>:
                  <div class="col-md-5 padding-right-0px">
                    <label class="margin-bottom-0px f2 color-Assign" *ngIf="CurrentNewBillData">{{CurrentNewBillData.NetPayable}}</label>
                  </div>
                </div>
              </div>

            </div>

          </div>

        </div>

      </div>
    </div>
  </div>

  <div class="columnnbv2  margin-top-17px">
    <div class="card height-100vh ">
      <div class="card-header wh-header  padding-bottom-0px padding-left-0px padding-right-0px padding-t-6px header-fixed">
        <div class="row border-bottom padding-bottom-5px margin-left-0px margin-right-0px" *ngIf="CurrentRefundListController2">
          <div class="col-md-5">
            <label class="margin-bottom-0px margin-left-5px">Refund Request</label>
          </div>
          <!--<div class="col-md-3">
            <search-list [title]="searchTitle" [hideTitle]="1" (change)="criteriaChange($event)"></search-list>
          </div>-->

          <div class="offset-md-3 col-md-4 float-right" *ngIf="CurrentRefundListController2.RequestMode=='Self Approval'">
            <div class="row float-right">
              <!--<div class="col-md-6 padding-right-0px">
                <search-list [title]="searchTitle" [hideTitle]="1" (change)="criteriaChange($event)"></search-list>
              </div>-->
              <div *canUserAccess="['HL_BL_6b']">
                <button class="btn actions-btn-prime font-size-13px margin-left-5px margin-right-5px float-right" (click)="AddData2()" *ngIf="CurrentRefundListController2.RefundStatus=='Pending'"><i class="fas fa-rupee-sign nav-link-hand font-size-12px margin-top-5px"></i> Pay</button>
              </div>
              <div *canUserAccess="['HL_BL_6c']">
                <button type="button"
                        class="btn btn-secondary font-size-13px margin-right-5px btn-raised button-Schedule actions-btn-prime actions-btn-prime3"
                        (click)="CancelRefund()" *ngIf="CurrentRefundListController2.RefundStatus=='Pending'">
                <i class="fa fa-times color-Rejected margin-right-3px"></i>Cancel Refund</button>
              </div>
              <button type="button" (click)="Back()" class="btn actions-btn-prime  font-size-13px margin-right-5px">Back</button>
            </div>
            <!--<button type="submit" class="btn actions-btn-prime font-size-13px margin-left-5px float-right"><i class="fa fa-print nav-link-hand font-size-12px margin-top-5px"></i> Print</button>-->



          </div>
          <div class="offset-md-3 col-md-4 float-right" *ngIf="CurrentRefundListController2.RequestMode=='Management Approval'">
            <div class="row float-right">

              <!--<button type="button" (click)="Approve()" class="btn actions-btn-prime  font-size-13px margin-right-5px" *ngIf="RefundRequestStatus=='Pending'">Approve</button>
              <button type="button" (click)="Reject()" class="btn actions-btn-prime  font-size-13px margin-right-5px" *ngIf="RefundRequestStatus=='Pending'">Reject</button>-->
              <label class="margin-bottom-0px color-green" *ngIf="CurrentRefundListController2.RefundRequestStatus=='APRVD' && CurrentRefundListController2.RefundStatus=='Pending'">Approved</label>
              <label class="margin-bottom-0px color-Rejected" *ngIf="CurrentRefundListController2.RefundRequestStatus=='Reject'">Rejected</label>
              <div *canUserAccess="['HL_BL_6b']">
                <button *ngIf="CurrentRefundListController2.RefundRequestStatus=='APRVD' && CurrentRefundListController2.RefundStatus=='Pending'"
                        class="btn actions-btn-prime font-size-13px margin-left-5px margin-right-5px float-right" (click)="AddData2()">
                  <i class="fas fa-rupee-sign nav-link-hand font-size-12px margin-top-5px"></i> Pay
                </button>
              </div>
              <button type="button" (click)="Back()" class="btn actions-btn-prime  font-size-13px margin-right-5px">Back</button>
            </div>

          </div>
        </div>
        <div class="row border-top border-bottom bk-color-light margin-left-0px margin-right-0px">
          <div class="col-md-2 border-right-1px padding-right-0px padding-left-0px text-align-center">
            <div class="height-18px"><label class="label-color-consultant font-size-12px font-weight-bold margin-bottom-0px data-color-new">Bill Date</label></div>
            <div><label class="margin-bottom-0px font-size-16px color-Assign" *ngIf="CurrentRefundListController2">{{CurrentRefundListController2.RefundRequestDate| date:'MMM-dd-yyyy'}}</label></div>
          </div>
          <div class="col-md-2 border-right-1px padding-right-0px padding-left-0px text-align-center">
            <div class="height-18px"><label class="label-color-consultant font-size-12px font-weight-bold margin-bottom-0px data-color-new">Branch</label></div>
            <div><label class="margin-bottom-0px font-size-16px color-Assign" *ngIf="BranchName">{{BranchName}}</label></div>
          </div>
          <div class="col-md-2 border-right-1px padding-right-0px padding-left-0px text-align-center">
            <div class="height-18px"><label class="label-color-consultant font-size-12px font-weight-bold margin-bottom-0px data-color-new">Total Bill</label></div>
            <div><label class="margin-bottom-0px font-size-16px color-Assign" *ngIf="BillTotal">{{BillTotal | number:'1.2-2'}}</label></div>
          </div>

          <div class="col-md-2 border-right-1px padding-right-0px padding-left-0px text-align-center">
            <div class="height-18px"><label class="label-color-consultant font-size-12px font-weight-bold margin-bottom-0px data-color-new">Discount</label></div>
            <div><label class="margin-bottom-0px font-size-16px color-Assign" *ngIf="Discount">{{Discount | number:'1.2-2'}}</label></div>
          </div>
          <div class="col-md-2 border-right-1px padding-right-0px padding-left-0px text-align-center">
            <div class="height-18px"><label class="label-color-consultant font-size-12px font-weight-bold margin-bottom-0px data-color-new">Net Paid</label></div>
            <div><label class="margin-bottom-0px font-size-16px color-Assign" *ngIf="NetPaid">{{NetPaid | number:'1.2-2'}}</label></div>
          </div>
          <!--<div class="col-md-2 border-right-1px padding-right-0px padding-left-0px text-align-center">
            <div class="height-18px"><label class="label-color-consultant font-size-12px font-weight-bold margin-bottom-0px data-color-new">Refund Date</label></div>
            <div><label class="margin-bottom-0px font-size-16px color-Assign" *ngIf="CurrentRefundListController2">{{CurrentRefundListController2.RefundDate | date:'MMM-dd-yyyy'}}</label></div>
          </div>-->
          <div class="col-md-2 border-right-1px padding-right-0px padding-left-0px text-align-center">
            <div class="height-18px"><label class="label-color-consultant font-size-12px font-weight-bold margin-bottom-0px data-color-new">Total Refundable</label></div>
            <div><label class="margin-bottom-0px font-size-16px color-Assign" *ngIf="CurrentRefundListController2">{{CurrentRefundListController2.ApprovedAmount | number:'1.2-2'}}</label></div>
          </div>
        </div>
      </div>
      <div class="card-body  padding-bottom-0px padding-left-0px padding-right-0px padding-top-92px">


        <!--<div class="row">
          <div class="col-md-12">
            <div class="table-component margin-bottom-0px">
              <div class="table-responsive overflow-x">


                <table class="table table-striped margin-left-20p table-fixed"
                       cols="auto,2*,*,*,*,*,*,*">

                  <thead class="">
                    <tr>

                      <th class="min-width-24px padding-top-4px padding-bottom-4px th-sticky">
                        #
                      </th>


                      <th class="padding-top-4px padding-bottom-4px th-sticky">
                        Service Description
                      </th>
                      <th class="padding-top-4px padding-bottom-4px th-sticky">
                        QTY
                      </th>

                      <th class="text-align-center padding-top-4px padding-bottom-4px th-sticky">
                        Unit Price
                      </th>

                      <th class="padding-top-4px padding-bottom-4px th-sticky">
                        Discount
                      </th>

                      <th class="text-align-center padding-top-4px padding-bottom-4px th-sticky">
                        Item Rate
                      </th>

                      <th class="padding-top-4px padding-bottom-4px th-sticky">

                      </th>






                    </tr>
                  </thead>





                </table>
              </div>
            </div>
          </div>
        </div>-->
        <!--<div class="row">
          <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
            <div class="card">


              <div class="card-header wh-header border-bottom padding-bottom-0px">
                <div class="row border-bottom">
                  <div class="col-md-12">
                    <label class="margin-bottom-0px">Payment</label>
                  </div>

                </div>
              </div>
              <div class="card-body padding-top-5px padding-bottom-0px">
                <div class="row">

                    <div class="col-md-12 padding-right-0px">
                      <div class="table-component">
                        <div class="table-responsive">


                          <table class="table table-striped margin-left-zero width-100">

                            <thead class="">
                              <tr>

                                <th class="min-width-0px"></th>
                                <th class="th-width-170px">Amount</th>

                                <th class="th-width-170px">Charges</th>
                                <th class="th-width-170px">Ref.No</th>
                                <th>Details</th>
                              </tr>
                            </thead>
                            <tbody class="table-body">

                              <tr>
                                <td class="td-padding">

                                    <input type="checkbox" class="width-23px height-16px margin-top-3px"
                                           [(ngModel)]="cash" />
                                    <i class="input-helper"></i>

                                    <label class="margin-bottom-0px position-absoulte margin-top-2px">Cash</label>



                                </td>
                                <td>
                                  <input type="text" class="form-control"
                                         min="1" max="10" *ngIf="cash">
                                </td>
                                <td class="text-align-right">
                                  <input type="text" class="form-control"
                                         min="1" max="10" *ngIf="cash">
                                </td>

                                <td class="td-padding ">

                                  <input type="text" class="form-control"
                                         min="1" max="10" *ngIf="cash">

                                </td>

                                <td>
                                  <input type="text" class="form-control"
                                         min="1" max="10" *ngIf="cash">
                                </td>



                              </tr>
                              <tr>
                                <td class="td-padding">

                                  <input type="checkbox" class="width-23px height-16px margin-top-3px"
                                         [(ngModel)]="card" />
                                  <i class="input-helper"></i>
                                  <label class="margin-bottom-0px position-absoulte margin-top-2px">Card</label>

                                </td>
                                <td>
                                  <input type="text" class="form-control"
                                         min="1" max="10" *ngIf="card">
                                </td>
                                <td class="text-align-right">
                                  <input type="text" class="form-control"
                                         min="1" max="10" *ngIf="card">
                                </td>

                                <td class="td-padding ">

                                  <input type="text" class="form-control"
                                         min="1" max="10" *ngIf="card">

                                </td>

                                <td>
                                  <input type="text" class="form-control"
                                         min="1" max="10" *ngIf="card">
                                </td>



                              </tr>
                              <tr>
                                <td class="td-padding">


                                  <input type="checkbox" class="width-23px height-16px margin-top-3px"
                                         [(ngModel)]="cheque" />
                                  <i class="input-helper"></i>
                                  <label class="margin-bottom-0px position-absoulte margin-top-2px">Cheque</label>

                                </td>
                                <td>
                                  <input type="text" class="form-control"
                                         min="1" max="10" *ngIf="cheque">
                                </td>
                                <td class="text-align-right">
                                  <input type="text" class="form-control"
                                         min="1" max="10" *ngIf="cheque">
                                </td>

                                <td class="td-padding ">

                                  <input type="text" class="form-control"
                                         min="1" max="10" *ngIf="cheque">

                                </td>

                                <td>
                                  <input type="text" class="form-control"
                                         min="1" max="10" *ngIf="cheque">
                                </td>



                              </tr>
                              <tr>
                                <td class="td-padding">

                                  <input type="checkbox" class="width-23px height-16px margin-top-3px"
                                         [(ngModel)]="demanddraft" />
                                  <i class="input-helper"></i>
                                  <label class="margin-bottom-0px position-absoulte margin-top-2px">Demand Draft</label>

                                </td>
                                <td>
                                  <input type="text" class="form-control"
                                         min="1" max="10" *ngIf="demanddraft">
                                </td>
                                <td class="text-align-right">
                                  <input type="text" class="form-control"
                                         min="1" max="10" *ngIf="demanddraft">
                                </td>

                                <td class="td-padding ">

                                  <input type="text" class="form-control"
                                         min="1" max="10" *ngIf="demanddraft">

                                </td>

                                <td>
                                  <input type="text" class="form-control"
                                         min="1" max="10" *ngIf="demanddraft">
                                </td>



                              </tr>
                              <tr>
                                <td class="td-padding">

                                  <input type="checkbox" class="width-23px height-16px margin-top-3px"
                                         [(ngModel)]="paytm" />
                                  <i class="input-helper"></i>
                                  <label class="margin-bottom-0px position-absoulte margin-top-2px">Paytm</label>

                                </td>
                                <td>
                                  <input type="text" class="form-control"
                                         min="1" max="10" *ngIf="paytm">
                                </td>
                                <td class="text-align-right">
                                  <input type="text" class="form-control"
                                         min="1" max="10" *ngIf="paytm">
                                </td>

                                <td class="td-padding ">

                                  <input type="text" class="form-control"
                                         min="1" max="10" *ngIf="paytm">

                                </td>

                                <td>
                                  <input type="text" class="form-control"
                                         min="1" max="10" *ngIf="paytm">
                                </td>



                              </tr>
                            </tbody>

                          </table>

                        </div>
                      </div>
                    </div>

                </div>
                                       </div>






            </div>
          </div>
        </div>-->

        <div class="chatsd product-chart-wrapper agreement-chart-wrapper ps2 padding-lrt height-80pe">
          <div class="row padding-top-3px">
            <div class="col-md-12">
              <div class="table-component">
                <div class="table-responsive overflow-x">


                  <table class="table table-striped margin-left-10px table-fixed"
                         cols="auto,2*,*,*,*,*,*,*">

                    <thead class="">
                      <tr>
                        <!--<th class="min-width-0px"></th>-->
                        <th class="min-width-24px padding-top-4px padding-bottom-4px th-sticky">
                          #
                        </th>


                        <th class="padding-top-4px padding-bottom-4px th-sticky">
                          Service Description
                        </th>
                        <th class="padding-top-4px padding-bottom-4px th-sticky">
                          QTY
                        </th>

                        <th class="text-align-center padding-top-4px padding-bottom-4px th-sticky">
                          Unit Price
                        </th>
                        <th class="text-align-center padding-top-4px padding-bottom-4px th-sticky">
                          Item Total
                        </th>
                        <th class="padding-top-4px padding-bottom-4px th-sticky">
                          Disc %
                        </th>
                        <th class="padding-top-4px padding-bottom-4px th-sticky">
                          Net
                        </th>

                        <!--<th class="">

                        </th>-->
                        <th class="padding-top-4px padding-bottom-4px th-sticky">
                          Refund QTY
                        </th>






                      </tr>
                    </thead>

                    <tbody class="table-body">
                      <tr *ngFor="let l of CurrentRefundItemsController;let i = index">


                        <td class="td-padding-tb">
                          {{i+1}}
                        </td>
                        <td class=" td-padding-tb">{{l.ItemDescription}}</td>

                        <td class="text-align-center td-padding-tb">
                          <!--<input type="number" class="form-control text-align-right td-width-82px" placeholder=""
                          [(ngModel)]="l.quantity"
                          maxlength="2" required>-->
                          <label class="margin-bottom-0px">{{l.Quantity}}</label>
                          <!--<input  type="number" class="form-control text-align-right td-width-82px" placeholder=""
                          [(ngModel)]="l.Quantity"
                          maxlength="2" required>-->
                          <!--<CodeTypeValue CodeType="1to5"
                                         id="l.Quantity" (keyChange)="Qunatitychange(l)"
                                         [(ngModel)]="l.Quantity" SelectedValue="l.Quantity"
                                         name="l.Quantity">
                          </CodeTypeValue>-->


                        </td>
                        <td class="text-align-center td-padding-tb padding-right-0px">{{l.UnitPrice | number:'1.2-2'}}</td>
                        <td class="td-padding-tb text-align-center padding-right-0px"> <label class="margin-bottom-0px">{{l.Quantity * l.UnitPrice | number:'1.2-2'}}</label></td>
                        <td class="td-padding-tb text-align-center max-width-10pe">


                          <label class="margin-bottom-0px">{{l.Discount | number:'1.2-2'}}</label>

                        </td>
                        <td class="text-align-center td-padding-tb padding-right-0px padding-left-0px">{{l.Net | number:'1.2-2'}}</td>
                        <td class=" td-padding-tb text-align-center td-width-10px">
                          <!--<CodeTypeValue *ngIf="l.IsSelected" CodeType="1to5"
                                         id="l.RefundQuantity" (keyChange)="Qunatitychange2(l)"
                                         [(ngModel)]="l.RefundQuantity" SelectedValue="l.RefundQuantity"
                                         name="l.RefundQuantity">
                          </CodeTypeValue>-->
                          <label *ngIf="!l.IsSelected" class="margin-bottom-0px">{{l.RefundQuantity}}</label>
                          <!--<a class="nav-link-hand education-navlink font-size-16px color-Assign" title="Edit Plan" (click)="Editrow()" *ngIf="Add">
                            <span class="badge"><i class="fas fa-pencil-alt"></i></span>
                          </a>-->
                          <!--<button type="submit" (click)="Editrow(l)" class="button-service-save font-size-16px color-secondary nav-link-hand margin-left-3px" title="Save" *ngIf="!l.Edit"><i class="fas fa-pencil-alt"></i></button>-->
                          <!--<a (click)="delete(i,l)" class="nav-link-hand font-size-16px color-Rejected" title="Remove"><i class="far fa-trash-alt nav-link-hand"></i></a>-->
                          <!--<button type="submit" (click)="OnClear(l)" class="button-service-save font-size-16px color-secondary nav-link-hand" title="Save" *ngIf="l.Edit"><i class="far fa-save"></i></button>
                          <button type="submit" (click)="OnClear(l)" class="button-service-save font-size-16px  nav-link-hand color-Rejected" title="Save" *ngIf="l.Edit"><i class="fa fa-times"></i></button>-->

                        </td>



                      </tr>
                    </tbody>



                  </table>
                </div>
              </div>
            </div>
          </div>



          <div class="row margin-left-0px" *ngIf="CurrentRefundListController2?.RefundRequestStatus=='Pending'">
            <div class="col-md-12">
              <div>
                <label class="margin-bottom-0px margin-top-5px">Comments </label>
              </div>
              <div class="form-group margin-bottom-0px">
                <!--<CodeTypeValue CodeType="FNSTS"></CodeTypeValue>-->
                <!--id="CurrentSaveSingleEmbryoGradeInfoRequest.Grade"
                [(ngModel)]="CurrentSaveSingleEmbryoGradeInfoRequest.Grade" SelectedValue="CurrentSaveSingleEmbryoGradeInfoRequest.Grade"
                name="CurrentSaveSingleEmbryoGradeInfoRequest.Grade">-->

                <textarea class="form-control3 col-md-11" rows="2" placeholder="Comments"
                          [(ngModel)]="Comments" required></textarea>


              </div>
            </div>
          </div>

          <div class="row col-md-12 margin-top-10">
            <div class="col-md-12" *ngIf="CurrentRefundListController2?.RequestMode=='Management Approval'">
              <div class="row offset-md-5">
                <div *canUserAccess="['HL_BL_6d']">
                  <button type="button" (click)="Approve()" class="btn actions-btn-prime  font-size-13px margin-right-5px" *ngIf="CurrentRefundListController2?.RefundRequestStatus=='Pending'">Approve</button>
                </div>
                <div *canUserAccess="['HL_BL_6d']">
                  <button type="button" (click)="Reject()" class="btn actions-btn-prime  font-size-13px margin-right-5px" *ngIf="CurrentRefundListController2?.RefundRequestStatus=='Pending'">Reject</button>
                </div>
                <!--<button type="button" (click)="Back()" class="btn actions-btn-prime  font-size-13px margin-right-5px">Back</button>-->
                <!--<label class="margin-bottom-0px color-green" *ngIf="RefundRequestStatus=='APRVD' && RefundStatus=='Pending'">Approved</label>
                <label class="margin-bottom-0px color-Rejected" *ngIf="RefundRequestStatus=='Reject'">Rejected</label>
                <button *ngIf="RefundRequestStatus=='APRVD' && RefundStatus=='Pending'"
                        class="btn actions-btn-prime font-size-13px margin-left-5px margin-right-5px float-right" (click)="AddData2()">
                  <i class="fas fa-rupee-sign nav-link-hand font-size-12px margin-top-5px"></i> Pay
                </button>-->


              </div>
              <!--<button type="submit" class="btn actions-btn-prime font-size-13px margin-left-5px float-right"><i class="fa fa-print nav-link-hand font-size-12px margin-top-5px"></i> Print</button>-->



            </div>
          </div>

          <!--<div class="row">
            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
              <div class="card">


                <div class="card-header wh-header border-bottom padding-bottom-0px">
                  <div class="row border-bottom">
                    <div class="col-md-12">
                      <label class="margin-bottom-0px">Payment</label>
                    </div>

                  </div>
                </div>
                <div class="card-body padding-top-5px padding-bottom-0px">
                  <div class="row">

                      <div class="col-md-12 padding-right-0px">
                        <div class="table-component">
                          <div class="table-responsive">


                            <table class="table table-striped margin-left-zero width-100">

                              <thead class="">
                                <tr>

                                  <th class="min-width-0px"></th>
                                  <th class="th-width-170px">Amount</th>

                                  <th class="th-width-170px">Charges</th>
                                  <th class="th-width-170px">Ref.No</th>
                                  <th>Details</th>
                                </tr>
                              </thead>
                              <tbody class="table-body">

                                <tr>
                                  <td class="td-padding">

                                      <input type="checkbox" class="width-23px height-16px margin-top-3px"
                                             [(ngModel)]="cash" />
                                      <i class="input-helper"></i>

                                      <label class="margin-bottom-0px position-absoulte margin-top-2px">Cash</label>



                                  </td>
                                  <td>
                                    <input type="text" class="form-control"
                                           min="1" max="10" *ngIf="cash">
                                  </td>
                                  <td class="text-align-right">
                                    <input type="text" class="form-control"
                                           min="1" max="10" *ngIf="cash">
                                  </td>

                                  <td class="td-padding ">

                                    <input type="text" class="form-control"
                                           min="1" max="10" *ngIf="cash">

                                  </td>

                                  <td>
                                    <input type="text" class="form-control"
                                           min="1" max="10" *ngIf="cash">
                                  </td>



                                </tr>
                                <tr>
                                  <td class="td-padding">

                                    <input type="checkbox" class="width-23px height-16px margin-top-3px"
                                           [(ngModel)]="card" />
                                    <i class="input-helper"></i>
                                    <label class="margin-bottom-0px position-absoulte margin-top-2px">Card</label>

                                  </td>
                                  <td>
                                    <input type="text" class="form-control"
                                           min="1" max="10" *ngIf="card">
                                  </td>
                                  <td class="text-align-right">
                                    <input type="text" class="form-control"
                                           min="1" max="10" *ngIf="card">
                                  </td>

                                  <td class="td-padding ">

                                    <input type="text" class="form-control"
                                           min="1" max="10" *ngIf="card">

                                  </td>

                                  <td>
                                    <input type="text" class="form-control"
                                           min="1" max="10" *ngIf="card">
                                  </td>



                                </tr>
                                <tr>
                                  <td class="td-padding">


                                    <input type="checkbox" class="width-23px height-16px margin-top-3px"
                                           [(ngModel)]="cheque" />
                                    <i class="input-helper"></i>
                                    <label class="margin-bottom-0px position-absoulte margin-top-2px">Cheque</label>

                                  </td>
                                  <td>
                                    <input type="text" class="form-control"
                                           min="1" max="10" *ngIf="cheque">
                                  </td>
                                  <td class="text-align-right">
                                    <input type="text" class="form-control"
                                           min="1" max="10" *ngIf="cheque">
                                  </td>

                                  <td class="td-padding ">

                                    <input type="text" class="form-control"
                                           min="1" max="10" *ngIf="cheque">

                                  </td>

                                  <td>
                                    <input type="text" class="form-control"
                                           min="1" max="10" *ngIf="cheque">
                                  </td>



                                </tr>
                                <tr>
                                  <td class="td-padding">

                                    <input type="checkbox" class="width-23px height-16px margin-top-3px"
                                           [(ngModel)]="demanddraft" />
                                    <i class="input-helper"></i>
                                    <label class="margin-bottom-0px position-absoulte margin-top-2px">Demand Draft</label>

                                  </td>
                                  <td>
                                    <input type="text" class="form-control"
                                           min="1" max="10" *ngIf="demanddraft">
                                  </td>
                                  <td class="text-align-right">
                                    <input type="text" class="form-control"
                                           min="1" max="10" *ngIf="demanddraft">
                                  </td>

                                  <td class="td-padding ">

                                    <input type="text" class="form-control"
                                           min="1" max="10" *ngIf="demanddraft">

                                  </td>

                                  <td>
                                    <input type="text" class="form-control"
                                           min="1" max="10" *ngIf="demanddraft">
                                  </td>



                                </tr>
                                <tr>
                                  <td class="td-padding">

                                    <input type="checkbox" class="width-23px height-16px margin-top-3px"
                                           [(ngModel)]="paytm" />
                                    <i class="input-helper"></i>
                                    <label class="margin-bottom-0px position-absoulte margin-top-2px">Paytm</label>

                                  </td>
                                  <td>
                                    <input type="text" class="form-control"
                                           min="1" max="10" *ngIf="paytm">
                                  </td>
                                  <td class="text-align-right">
                                    <input type="text" class="form-control"
                                           min="1" max="10" *ngIf="paytm">
                                  </td>

                                  <td class="td-padding ">

                                    <input type="text" class="form-control"
                                           min="1" max="10" *ngIf="paytm">

                                  </td>

                                  <td>
                                    <input type="text" class="form-control"
                                           min="1" max="10" *ngIf="paytm">
                                  </td>



                                </tr>
                              </tbody>

                            </table>

                          </div>
                        </div>
                      </div>

                  </div>
                                         </div>






              </div>
            </div>
          </div>-->
        </div>
      </div>
      <!--<div class="row">
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
          <div class="card">


            <div class="card-header wh-header border-bottom padding-bottom-0px">
              <div class="row border-bottom">
                <div class="col-md-4">
                  <label class="margin-bottom-0px">Discount : </label>
                </div>
                <div class="col-md-4">
                  <label class="margin-bottom-0px">Discount(%) :</label>
                </div>
                <div class="col-md-4">
                  <label class="margin-bottom-0px">Total :</label>
                </div>
              </div>
            </div>






          </div>
        </div>
      </div>-->




    </div>
  </div>

  <div class="columnbp3 background-white margin-top-17px">

    <div class="position-fixed-Activities3">
      <div class="card">
        <div class="card-header border-left-clinical font-size-16px border-top-1px border-right-1px border-bottom-1px border-radius-5px wh-header padding-top-3px padding-bottom-3px padding-right-0px padding-left-9px">
          Bill Information
        </div>
        <div class="card-body padding-top-0px padding-left-0px padding-right-0px margin-left-0px">
          <div class=" margin-top-5px">
            <div class="row font-weight-700 margin-left-0px margin-right-0px">
              <!--<div class="col-md-4 text-align-right padding-right-7px">
                <label class="font-size-12px font-weight-normal margin-bottom-0px white-space-pre">Patient Name</label>
              </div>:-->
              <div class="col-md-9 font-size-12px font-weight-normal padding-right-0px" *ngIf="CurrentX_BillHeaderController">
                <label class="font-size-12px margin-top-5px font-weight-normal margin-bottom-0px color-Assign">{{CurrentX_BillHeaderController.PatientName}}</label>

              </div>
            </div>
            <div class="row font-weight-700">
              <div class="col-md-5 text-align-right padding-right-5px">
                <label class="font-size-12px font-weight-normal margin-bottom-0px">Refund Req Date  </label>
              </div>:
              <div class="col-md-6 font-size-12px font-weight-normal" *ngIf="CurrentRefundListController2">

                <label class="font-size-12px margin-top-5px font-weight-normal margin-bottom-0px">{{CurrentRefundListController2.RefundRequestDate | date:'MMM-dd-yyyy'}}</label>
              </div>
            </div>

            <div class="row font-weight-700">
              <div class="col-md-5 text-align-right">
                <label class="font-size-12px font-weight-normal margin-bottom-0px">Branch  </label>
              </div>:
              <div class="col-md-6 font-size-12px font-weight-normal" *ngIf="BranchName">

                <label class="font-size-12px margin-top-5px font-weight-normal margin-bottom-0px">{{BranchName}}</label>
              </div>
            </div>
            <!--<div class="row font-weight-700">
              <div class="col-md-4 text-align-right">
                <label class="font-size-12px font-weight-normal margin-bottom-0px">Bill By</label>
              </div>:
              <div class="col-md-5 font-size-12px margin-top-3px font-weight-normal" *ngIf="CurrentRefundListController2">
                <label class="font-size-14 font-weight-normal margin-bottom-0px">{{CurrentRefundListController2.PayerName}}</label>

              </div>
            </div>-->
            <div class="row font-weight-700">
              <div class="col-md-5 text-align-right">
                <label class="font-size-12px font-weight-normal margin-bottom-0px"> Total Bill </label>
              </div>:
              <div class="col-md-5 font-size-12px font-weight-normal" *ngIf="CurrentRefundListController2">

                <label class="font-size-12px margin-top-5px font-weight-normal margin-bottom-0px">{{CurrentRefundListController2.BillTotal | number:'1.2-2'}}</label>
              </div>
            </div>
            <div class="row font-weight-700">
              <div class="col-md-5 text-align-right">
                <label class="font-size-12px font-weight-normal margin-bottom-0px"> Discount </label>
              </div>:
              <div class="col-md-5 font-size-12px font-weight-normal" *ngIf="CurrentRefundListController2">

                <label class="font-size-12px margin-top-5px font-weight-normal margin-bottom-0px">{{CurrentRefundListController2.Discount | number:'1.2-2'}}</label>
              </div>
            </div>
            <div class="row font-weight-700">
              <div class="col-md-5 text-align-right">
                <label class="font-size-12px font-weight-normal margin-bottom-0px"> Net  </label>
              </div>:
              <div class="col-md-5 font-size-12px font-weight-normal" *ngIf="CurrentRefundListController2">

                <label class="font-size-12px margin-top-5px font-weight-normal margin-bottom-0px">{{CurrentRefundListController2.NetPaid | number:'1.2-2'}}</label>
              </div>
            </div>

            <div class="row font-weight-700">
              <div class="col-md-5 text-align-right">
                <label class="font-size-12px font-weight-normal margin-bottom-0px">Refund Mode  </label>
              </div>:
              <div class="col-md-6 font-size-12px font-weight-normal" *ngIf="CurrentRefundListController2">

                <label class="font-size-12px margin-top-5px font-weight-normal margin-bottom-0px">{{CurrentRefundListController2.RequestMode}}</label>
              </div>
            </div>
            <div class="row font-weight-700">
              <div class="col-md-5 text-align-right">
                <label class="font-size-12px font-weight-normal margin-bottom-0px">Refund Reason  </label>
              </div>:
              <div class="col-md-6 font-size-12px font-weight-normal" *ngIf="CurrentRefundListController2">

                <label class="font-size-12px margin-top-5px font-weight-normal margin-bottom-0px">{{CurrentRefundListController2.RefundReason}}</label>
              </div>
            </div>
            <div class="row font-weight-700">
              <div class="col-md-5 text-align-right">
                <label class="font-size-12px font-weight-normal margin-bottom-0px">Refund Req By</label>
              </div>:
              <div class="col-md-6 font-size-12px margin-top-3px font-weight-normal" *ngIf="CurrentRefundListController2">
                <label class="font-size-14 font-weight-normal margin-bottom-0px">{{CurrentRefundListController2.RefundRequestedUserName}}</label>

              </div>
            </div>
            <!--<div class="row font-weight-700">
              <div class="col-md-4 text-align-right">
                <label class="font-size-12px font-weight-normal margin-bottom-0px"> Paid Bill </label>
              </div>:
              <div class="col-md-5 font-size-12px font-weight-normal" *ngIf="PaidBill">

                <label class="font-size-12px margin-top-5px font-weight-normal margin-bottom-0px">{{PaidBill | number:'1.0-0' |removeComma}}</label>
              </div>
            </div>-->
          </div>

          <!--<div class="accordion" id="accordionExampleSections">
            <div class="card margin-bottom-5px">
              <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingSection">
                <div class="row">
                  <div class="col-md-5">
                    <h5 class="mb-0 height-24px">
                      <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapseSection" aria-expanded="true" aria-controls="collapseSection">
                        Billing Sections
                      </button>
                    </h5>
                  </div>

                </div>


              </div>

              <div id="collapseSection" class="collapse show" aria-labelledby="headingSection" data-parent="#accordionExampleSection">
                <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">
                  <div class="row card margin-left-0px margin-right-0px margin-bottom-5px">
                    <a class="nav-link-hand margin-left-10px margin-top-5px  font-size-12px font-weight-bold" (click)="header()">Bill Header</a>




                  </div>
                  <div class="row card margin-left-0px margin-right-0px margin-bottom-5px">
                    <a class="nav-link-hand margin-left-10px margin-top-5px  font-size-12px font-weight-bold" (click)="items()">Services</a>




                  </div>
                  <div class="row card margin-left-0px margin-right-0px margin-bottom-5px">
                    <a class="nav-link-hand margin-left-10px margin-top-5px  font-size-12px font-weight-bold" (click)="Receipts()">Advances</a>




                  </div>


                  <div class="row card margin-left-0px margin-right-0px margin-bottom-5px">
                    <a class="nav-link-hand margin-left-10px margin-top-5px  font-size-12px font-weight-bold" (click)="Receipts()">Receipts</a>




                  </div>


                </div>
              </div>
            </div>
          </div>-->


        </div>
      </div>
    </div>





  </div>


</div>
